import styled from '@emotion/styled'
import { css } from '@emotion/css'

export const CheckboxGroupDefaultClass = css``

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 13px;
`
